import GeoSelectOption from '@/common/components/GeoSelectOption'
import { formatCurrency, formatDecimal, formatUnit } from '@/common/utils/formatters'
import { options as priceRuleOptions } from '@/features/publicCompanyLeadsFunnel/constants/priceRuleOptions.constant'
import { PublicCompanyLeadsFunnelContractProductCategoryValidationSchema } from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import {
  ContractProductCategoryData,
  PublicCompanyLeadData,
} from '@/features/publicCompanyLeadsFunnel/types/publicCompanyLead'

export const publicCompanyLeadContractProductCategoriesDefaultValues: (props: {
  lead?: PublicCompanyLeadData
  contractProductCategory: ContractProductCategoryData
}) => PublicCompanyLeadsFunnelContractProductCategoryValidationSchema = ({ lead, contractProductCategory }) => ({
  id: contractProductCategory.id,
  product_category: contractProductCategory.product_category,
  require_product_credit_quota: lead?.contract?.require_product_credit_quota || false,
  global_value_in_currency: formatCurrency(Number(contractProductCategory.global_value_in_currency) || 0),
  global_value_in_unit_for_consumption: formatUnit(
    formatDecimal(contractProductCategory.global_value_in_unit_for_consumption || 0, 2),
    '',
  ),
  contract_product_category_products: contractProductCategory.contract_product_category_products?.map(
    (productPrice) => ({
      id: productPrice.id,
      product: productPrice.product,
      price_rule: priceRuleOptions.find((option) => option.value === productPrice.price_rule),
      filterByRegion: productPrice.contract_product_category_product_prices?.some((price) => !!price.geo),
      global_value_in_currency: productPrice?.global_value_in_currency
        ? formatCurrency(Number(productPrice.global_value_in_currency) || 0)
        : '',
      global_value_in_unit_for_consumption: productPrice?.global_value_in_unit_for_consumption
        ? formatUnit(
            formatDecimal(
              productPrice.global_value_in_unit_for_consumption || 0,
              productPrice.product?.unit_for_quantity === 'item' ? 0 : 2,
            ),
            productPrice.product?.unit_for_quantity,
          )
        : '',
      contract_product_category_product_prices: productPrice.contract_product_category_product_prices?.map((price) => ({
        id: price.id,
        value: price.value ? formatCurrency(Number(price.value) || 0) : '',
        geo: price.geo ? {
            value: price.geo?.id,
            label: <GeoSelectOption geo={price.geo} />,
            type: 'Geo::City',
          } : undefined,
      })),
    }),
  ),
})
